// GuildForm.js
import React, { useState } from 'react';
import { format, nextWednesday, nextFriday, startOfWeek } from 'date-fns';
import '../styles/Guild.css';

const GuildForm = ({ onGuildSubmit, guildNames }) => {
  const [guildName, setGuildName] = useState('');
  const [opponentGuildName, setOpponentGuildName] = useState('');
  const [battleDate, setBattleDate] = useState('');

  // 今週の水、金曜日の日付を計算
  const today = new Date();
  const thisWeekStart = startOfWeek(today, { weekStartsOn: 1 });
  const wednesday = format(nextWednesday(thisWeekStart), 'yyyy-MM-dd');
  const friday = format(nextFriday(thisWeekStart), 'yyyy-MM-dd');

  const sortedGuildNames = [...guildNames].sort((a, b) => a.lastGuildWarRank - b.lastGuildWarRank);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (guildName === opponentGuildName) {
      alert('Same guild cannot be selected');
      return;
    }
    onGuildSubmit(guildName, opponentGuildName, battleDate);
    setGuildName('');
    setOpponentGuildName('');
    setBattleDate('');
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} className="guild-form-simple">
        <div className="guild-vs-container">
          <select
            value={guildName}
            onChange={(e) => setGuildName(e.target.value)}
            required
            className="form-select-simple"
          >
            <option value="">Select Guild</option>
            {sortedGuildNames.map((guild) => (
              <option key={guild.gid} value={guild.name}>
                {`[${guild.lastGuildWarRank}位] ${guild.name}`}
              </option>
            ))}
          </select>

          <span className="vs-text">VS</span>

          <select
            value={opponentGuildName}
            onChange={(e) => setOpponentGuildName(e.target.value)}
            required
            className="form-select-simple"
          >
            <option value="">Select Opponent</option>
            {sortedGuildNames.map((guild) => (
              <option key={guild.gid} value={guild.name}>
                {`[${guild.lastGuildWarRank}位] ${guild.name}`}
              </option>
            ))}
          </select>
        </div>

        <div className="date-select-container">
          <select
            value={battleDate}
            onChange={(e) => setBattleDate(e.target.value)}
            required
            className="form-select-simple date-select"
          >
            <option value="">Select Battle Date</option>
            <option value={wednesday}>Wednesday</option>
            <option value={friday}>Friday</option>
          </select>

          <button type="submit" className="submit-button-simple">
            Register
          </button>
        </div>
      </form>
    </div>
  );
};

export default GuildForm;
